








import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const auth = namespace('auth')

@Component
export default class Logout extends Vue {
  @auth.Action logout!: () => void
}
